import React, { useEffect, useState, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import Language from './Language';
import logoIMA from '../../img/menu/logo-groupe-ima.png';
import { useTranslation } from 'react-i18next';
import InputBase from '@material-ui/core/InputBase';
import PersonIcon from '@material-ui/icons/Person';
import MenuItem from '../core/MenuItem';
import { useHistory } from "react-router-dom";
import CloseIcon from '@material-ui/icons/Close';
import check from "../rbac/check";
import AdminService from '../../service/AdminService';
import UserUtils from '../utils/UserUtils';
import styled from 'styled-components';
// import Cookies from 'universal-cookie';

const SlideTrack = styled.div`
  @keyframes scroll {
    0% { transform: translateX(0); }
    100% { transform: translateX(calc(-250px * ${props => (props.nb ? props.nb : 1)}))}
  }
  animation: scroll ${props => (props.nb ? props.nb * 15 : 0)}s linear infinite;
  display: flex;
  width: calc(250px * ${props => (props.nb ? props.nb * 2 : 1)});
`

const mapStateToProps = (state) => {
  return {
    menuActive: state.reduceMenu.menuActive,
    customer: state.reduceLogo.customer,
    site: state.reduceLogo.site
  }
}

export default connect(mapStateToProps)(NavBar);

function NavBar(props) {
  let history = useHistory();
  const classes = useStyles();
  const [open, setOpen] = useState(props.open);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [freeSearch, setFreeSearch] = useState('');
  const searchInputRef = useRef(null);
  const [user] = useState(UserUtils.getUser());
  const { t } = useTranslation('common');
  const [logos, setLogos] = useState([]);
  const [logoCase, setLogoCase] = useState();
  // const cookies = new Cookies(null, { path: '/' });

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  useEffect(() => {
    if (logos && props.customer && props.site) {
      setLogoCase(logos.find(l => l.customer === props.site + props.customer));
    } else {
      setLogoCase(undefined);
    }
  }, [props.customer]);


  useEffect(() => {
    if (!user.ima) {
      const clients = user.code_client;
      if (clients) {
        let query = [];
        clients.forEach(siteAndCode => {
          const site = siteAndCode.substring(0, 1);
          const code = siteAndCode.substring(1, siteAndCode.length);
          query.push({
            "customerCode": code,
            "siteCode": site
          });
        });
        updateLogos(query);
      }
    }
  }, []);

  useEffect(() => {
    const unlisten = history.listen((location) => {
      // Vérifier si l'utilisateur navigue vers la page de suivi des réparations
      if (location.pathname === '/console-repairs') {
        resetSearch();
      }
    });

    // Nettoyage de l'écouteur lors du démontage du composant
    return () => {
      unlisten();
    };
  }, [history]);

  // Fonction pour réinitialiser la recherche
  const resetSearch = () => {
    setFreeSearch('');
    if (searchInputRef.current) {
      searchInputRef.current.value = '';
    }
    props.dispatch({
      type: "FREE_SEARCH",
      contenu: {
        'value': '',
        'immediate': false
      }
    });
  };

  // Réupération des logos
  const updateLogos = (query) => {
    AdminService.getCutomersLogo(query).then((res) => {
      if (res && res.data && res.data.length > 0) {
        let logos = [];
        let doublon = [];
        res.data.forEach(d => {
          if (!doublon.includes(d.logo.name)) {
            const logo = {};
            logo.img = d.logo
            logo.customer = d.siteCode + d.customerCode;
            logos.push(logo);
            doublon.push(d.logo.name);
          }
        })
        setLogos(logos);
      }
    });
  }

  const logout = () => {
    history.push('/');
    localStorage.setItem("token", undefined);
    // cookies.remove("token");
    props.keycloak.logout()
  };

  const onChangeSearch = () => event => {
    // ajout du texte dans le filtre spécfique
    setFreeSearch(event.target.value);
    props.dispatch({
      type: "FREE_SEARCH",
      contenu: {
        'value': event.target.value,
        'immediate': false
      }
    })
  };

  const keyPress = event => {
    if (13 == event.keyCode) {
      onSearch();
    }
  }

  const onSearch = () => {
    let redirection;
    if (props.menuActive === 'console-cases') {
      if (check("console-cases:visit")) {
        props.dispatch({
          type: 'MENU',
          menuActive: 'console-cases'
        });
        redirection = '/console-cases?free=t';
      }
    } else if (props.menuActive === "console-guarantees") {
      if (check("guarantee:visit")) {
        props.dispatch({
          type: 'MENU',
          menuActive: 'console-guarantees'
        });
        redirection = '/console-guarantees?free=t';
      }
    } else {
      if (check("search-cases:visit")) {
        props.dispatch({
          type: 'MENU',
          menuActive: 'search-cases'
        });
        redirection = '/search-cases?free=t';
      }
    }
    if (redirection) {
      window.dataLayer.push({
        freeSearch: freeSearch
      });

      props.dispatch({
        type: "FREE_SEARCH",
        contenu: {
          'value': freeSearch,
          'immediate': true
        }
      })
      history.push(redirection);
    } else {
      history.push('/error?error=403');
    }
  }

  const userInfoComponent = useMemo(() => {
    return (<>
      <div className="menuIcon">
        <PersonIcon />
      </div>
      <span>{user.name}</span>
    </>);
  });

  const gotToInformations = () => {
    history.push("/my-informations");
  };

  const getUserItems = useMemo(() => {
    let items = {};
    items[t('NAV008')] = gotToInformations;
    items[t('NAV001')] = () => setOpenConfirm(true);
    return items;
  });

  const memoLogos = useMemo(() => {
    if (logoCase) {
      return <img height='62px' src={`data:${logoCase.img.type};base64,${logoCase.img.data}`} />
    } else if (logos && logos.length) {
      if (logos.length === 1) {
        return <img height='62px' src={`data:${logos[0].img.type};base64,${logos[0].img.data}`} />
      } else {
        let resLogos = [];
        logos.forEach(logo => {
          resLogos.push(
            <div class="slideLogo">
              <img height='62px' src={`data:${logo.img.type};base64,${logo.img.data}`} />
            </div>
          )
        });
        logos.forEach(logo => {
          resLogos.push(
            <div class="slideLogo">
              <img height='62px' src={`data:${logo.img.type};base64,${logo.img.data}`} />
            </div>
          )
        });
        return (
          <div class="sliderLogo">
            <SlideTrack nb={logos.length} >
              {resLogos}
            </SlideTrack>
          </div>
        )
      }
    } else {
      return <img src={logoIMA} height='42px'></img>
    }
  })

  return (
    <AppBar position="fixed" className={clsx(classes.appBar, { [classes.appBarShift]: open, })}>
      <Toolbar className={classes.toolbar}>
        <IconButton color="inherit" aria-label="open drawer" onClick={() => props.onDrawpen(true)} edge="start"
          className={clsx(classes.menuButton, { [classes.hide]: open, })}>
          <MenuIcon />
        </IconButton>

        <div className={classes.search}>
          <div className={classes.searchIcon} onClick={onSearch}>
            <SearchIcon />
          </div>
          <InputBase placeholder={user?.ima ? t('NAV006') : t('NAV003')} className={classes.input} onKeyDown={keyPress} onChange={onChangeSearch()} inputRef={searchInputRef} />
        </div>

        <Language />

        <MenuItem title={userInfoComponent} items={getUserItems} />

        <div className={classes.logo}>
          {memoLogos}
        </div>

      </Toolbar>
      <div className={openConfirm ? 'overlay open' : 'overlay'}>
        <div className="popup logout">
          <CloseIcon onClick={() => setOpenConfirm(false)} className="close" />
          <h1>{t('NAV004')}</h1>
          <div className="actions">
            <span className="cancel" onClick={() => setOpenConfirm(false)}>{t('NAV005')}</span>
            <span className="confirm" onClick={logout}>{t('NAV001')}</span>
          </div>
        </div>
      </div>
    </AppBar>
  );
}

const drawerWidth = 240;
const useStyles = makeStyles(theme => ({
  logo: {
    width: '10%',
  },
  toolbar: {
    minHeight: '84px',
    paddingLeft: '16px',
    justifyContent: 'space-between',
    display: 'flex',
    alignItems: 'center',
  },
  appBar: {
    boxShadow: 'none',
    background: '#FFF',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    color: '#c8c8d4',
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#f6f5fb',
    color: '#9696A0',
    width: '40%'
  },
  input: {
    margin: '3px',
    padding: '7px',
    left: theme.spacing(7),
    width: '95%',
    color: '#9696A0'
  },
  searchIcon: {
    color: '#c8c8d4',
    width: theme.spacing(7),
    height: '100%',
    cursor: 'pointer',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
}));